import { StreamOwnerPaymentClient, ArticleOwnerPaymentDTO, IssueTailorPaymentDTO, StreamTailorPaymentClient, ContentStreamArticleOwnerBatchDTO, ContentStreamArticleOwnerBatchItemDTO, ContentStreamIssueTailoringBatchDTO, ContentStreamIssueTailoringBatchItemDTO, OwnerPaymentDTO, TailoringPaymentDTO } from "@/Generated/ParticaAPI";

export interface IContentStreamPaymentService {
	GetOutstandingOwner(): Promise<ArticleOwnerPaymentDTO[]>;
	GetOutstandingTailor(): Promise<IssueTailorPaymentDTO[]>;
	GetAvailableOwnerMonths(): Promise<string[]>;
	GetAvailableTailorMonths(): Promise<string[]>;
	CreateOwnerBatch(month: string): Promise<any>;
	CreateTailorBatch(month: string): Promise<any>;
	GetOwnerBatches(): Promise<ContentStreamArticleOwnerBatchDTO[]>;
	GetTailorBatches(): Promise<ContentStreamIssueTailoringBatchDTO[]>;
	GetOwnerBatchItems(id: number): Promise<ContentStreamArticleOwnerBatchItemDTO[]>;
	GetTailorBatchItems(id: number): Promise<ContentStreamIssueTailoringBatchItemDTO[]>;
	GetAccountPayments(accountId: number): Promise<OwnerPaymentDTO[]>;
	GetTailoringPayments(accountId: number): Promise<TailoringPaymentDTO[]>;
	PayArticeOwners(batchId: number): Promise<any>;
	PayTailoringFees(batchId: number): Promise<any>;
}

export class ContentStreamPaymentService implements IContentStreamPaymentService {
	private ownerclient: StreamOwnerPaymentClient = new StreamOwnerPaymentClient();
	private tailorclient: StreamTailorPaymentClient = new StreamTailorPaymentClient();

	public async PayArticeOwners(batchId: number): Promise<any> {
		return await this.ownerclient.payBatch(batchId);
	}
	public async PayTailoringFees(batchId: number): Promise<any> {
		return await this.tailorclient.payBatch(batchId);
	}

	public async GetAccountPayments(accountId: number): Promise<OwnerPaymentDTO[]> {
		const data: OwnerPaymentDTO[] = await this.ownerclient.getAccountPayments(accountId);
		data.forEach(p => {
			if (p.batch === null) {
				p.batch = "Outstanding";
			}
		});
		return data;
	}

	public async GetTailoringPayments(accountId: number): Promise<TailoringPaymentDTO[]> {
		const data: TailoringPaymentDTO[] = await this.tailorclient.getAccountPayments(accountId);
		data.forEach(p => {
			if (p.batch === null) {
				p.batch = "Outstanding";
			}
		});
		return data;
	}

	public async GetTailorBatchItems(id: number): Promise<ContentStreamIssueTailoringBatchItemDTO[]> {
		return await this.tailorclient.getBatch(id);
	}
	public async GetAvailableTailorMonths(): Promise<string[]> {
		return await this.tailorclient.getAvailableBatches();
	}
	public async GetOwnerBatchItems(id: number): Promise<ContentStreamArticleOwnerBatchItemDTO[]> {
		return await this.ownerclient.getBatch(id);
	}
	public async GetTailorBatches(): Promise<ContentStreamIssueTailoringBatchDTO[]> {
		return await this.tailorclient.getBatches();
	}
	public async GetOwnerBatches(): Promise<ContentStreamArticleOwnerBatchDTO[]> {
		return await this.ownerclient.getBatches();
	}
	public async CreateTailorBatch(month: string): Promise<any> {
		return await this.tailorclient.createBatch(month);
	}
	public async CreateOwnerBatch(month: string): Promise<any> {
		return await this.ownerclient.createBatch(month);
	}
	public async GetAvailableOwnerMonths(): Promise<string[]> {
		return await this.ownerclient.getAvailableBatches();
	}
	public async GetOutstandingOwner(): Promise<ArticleOwnerPaymentDTO[]> {
		return await this.ownerclient.getOutstanding();
	}
	public async GetOutstandingTailor(): Promise<IssueTailorPaymentDTO[]> {
		return await this.tailorclient.getOutstanding();
	}

}
